import get from 'lodash/get';
import map from 'lodash/map';
import * as TYPES from '../../constants/actionTypes';
import { axiosInstance } from '../../utilities/configureAxios';

const initialState = {
  user: null,
  token: null,
  isLoggedIn: false,
  currentHospital: null,
  currentDoctor: null,
  hospitals: null,
  roles: null,
  tempPassword: null,
  currentRole: null,
  allRoles: null,
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case TYPES.LOGIN:
      const userRoles = get(action, 'data.user.roles', []);
      const currentRole = get(action, 'data.user.currentRole');
      return {
        ...state,
        token: get(action, 'data.access_token'),
        user: get(action, 'data.user'),
        isLoggedIn: true,
        currentHospital: get(action, 'data.currentHospital'),
        currentDoctor: get(action, 'data.currentDoctor'),
        hospitals: get(action, 'data.hospitals'),
        roles: currentRole ? [currentRole.value] : map(userRoles, (role) => role.value),
        allRoles: userRoles,
        currentRole: currentRole || userRoles[0],
        id: get(action, 'data.user.id'),
        tempPassword: get(action, 'data.password'),
      };

    case TYPES.LOGOUT:
      return {
        ...state,
        user: null,
        token: null,
        isLoggedIn: false,
        currentDoctor: null,
        currentHospital: null,
        hospitals: null,
        roles: null,
        tempPassword: null,
        currentRole: null,
        allRoles: null,
      };

    case TYPES.SWITCH:
      return {
        ...state,
        token: get(action, 'data.access_token'),
        user: get(action, 'data.user'),
        currentHospital: get(action, 'data.currentHospital'),
        currentDoctor: get(action,'data.currentDoctor'),
        roles: map(get(action, 'data.user.roles'), (role) => role.value),
        hospitals: get(action, 'data.hospitals'),
        id: get(action, 'data.user.id'),
      };

    case TYPES.UPDATE:
      return {
        ...state,
        user: get(action, 'data'),
      };

    // return {
    //   ...state,
    //   token: get(action, 'data.access_token'),
    //   user: get(action, 'data'),
    //   isLoggedIn: true,
    //   role: get(action, 'data.role_id'),
    // };

    case 'persist/REHYDRATE':
      if (get(action.payload, 'auth.token', null)) {
        axiosInstance.defaults.headers.common.authorization = `Bearer ${get(
          action.payload,
          'auth.token',
          null,
        )}`;
      }

      return state;

    default:
      return state;
  }
}
